<!--
    file type .....: HTML file: agencytable.component.html
    Created By ....: ianday
    Date ..........: 10/12/23 
-->
<div class="agencytable-container">

    <div class="table-container" id="tblAgencyContainerId"
         (keydown)="tableKeyDown($event)" tabindex="-1">
        <table mat-table [dataSource]="dataSource"
               style="width:100%; border:none;">

            <ng-container matColumnDef="id" >
                <th mat-header-cell class="mat-table-header-style"
                    *matHeaderCellDef [hidden]="true">Id</th>
                <td mat-cell style="width: 5%;" [hidden]="true"
                    *matCellDef="let element">{{element.id}}</td>
            </ng-container>

            <ng-container matColumnDef="agencyName">
                <th mat-header-cell class="mat-table-header-style" style="border-bottom: 1px solid silver;"
                    *matHeaderCellDef>Agency Name:
                    <div style="display: inline-block; font-weight: normal;vertical-align: middle;
                    width:150px;text-align: right;padding-right:5px;"> Filter: </div>
                    <div style="display: inline-block;
                    font-weight: normal;vertical-align: middle;
                    width:70px;text-align: left;">{{filterStr}}</div>
                </th>
                <td mat-cell style="width: 100%;font-size: 9pt; padding-left: 3px;"
                    *matCellDef="let element">{{element.agencyName}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"
            style="background-color: silver !important;" ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;let tableRowIdx = index;"
                [id]="row.id" #tableRows
				[ngClass]="{'row-selected': tableRowIdx == Idx}"
                (click)="onRowClicked(row)" (dblclick)="doubleClickRow()">

            </tr>
        </table>
        <div class="save-close-strip" style="bottom: 10px;">

            <button  class="command-button"
                     (click)="submitRecord()" matTooltip="Submit the selected record"
                     mat-button>
                <mat-icon>check_circle_outline</mat-icon>
                Submit
            </button>
            <button class="command-button"
                    (click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
                <mat-icon>highlight_off</mat-icon>
                Cancel
            </button>
        </div>
    </div>
</div>


